import user from './index.vue'

// 为组件提供 install 安装方法，供按需引入
user.install = Vue => {
  Vue.component(user.name, user)
}

// 默认导出组件
export default user

